import script from "./ContentNavigationWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentNavigationWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./ContentNavigationWrapper.vue?vue&type=style&index=0&id=f619e144&lang=scss"

const __exports__ = script;

export default __exports__